module.exports = __webpack_public_path__ + "static/media/quince_compote.b0185db7.png";